module.exports = __webpack_public_path__ + "static/img/pic16.71e4a08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic16.png
// module id = kzlm
// module chunks = 0